module.exports = __webpack_public_path__ + "img/FR10807.7e422894.png";